import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import './Rating.less';
import formatMessage from '../../../utils/formatMessage';

const Rating = ({averageRating, reviewCount, starSize, messages}) => {
    if (!reviewCount) {
        return <span className="sr-only">{messages.noReviews}</span>;
    }

    return (
        <Fragment>
            <div className={'Rating__starRating'} aria-hidden="true">
                <StarRating rating={averageRating} size={starSize} />
            </div>
            <span className="Rating__ratingcount" aria-hidden="true">
                {`(${reviewCount})`}
            </span>
            <span className="sr-only">
                {formatMessage(messages.ratingScreenReaderLabel, {
                    rating: averageRating.toFixed(2),
                    reviewCount
                })}
            </span>
        </Fragment>
    );
};

export default Rating;
